import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import LayoutDefault from "layouts/Default";
import LayoutBlank from "layouts/Blank";

import Dashboard from "views/Dashboard";
import Blank from "views/Blank";
import FormComponents from "views/FormComponents";
import FormInputGroups from "views/FormInputGroups";
import FormLayout from "views/FormLayout";
import FormValidations from "views/FormVaidations";
import FormWizards from "views/FormWizards";
import ComponentsAlerts from "views/ComponentsAlerts";
import ComponentsAvatars from "views/ComponentsAvatars";
import ComponentsBadges from "views/ComponentsBadges";
import ComponentsButtons from "views/ComponentsButtons";
import ComponentsCards from "views/ComponentsCards";
import ComponentsCollapse from "views/ComponentsCollapse";
import ComponentsColors from "views/ComponentsColors";
import ComponentsDropdowns from "views/ComponentsDropdowns";
import ComponentsModal from "views/ComponentsModal";
import ComponentsPopoversTooltips from "views/ComponentsPopoversTooltips";
import ComponentsTables from "views/ComponentsTables";
import ComponentsTabs from "views/ComponentsTabs";
import ComponentsToasts from "views/ComponentsToasts";
import ExtrasCarousel from "views/ExtrasCarousel";
import ExtrasCharts from "views/ExtrasCharts";
import ExtrasEditors from "views/ExtrasEditors";
import ExtrasFullCalandar from "views/ExtrasFullCalendar";
import ExtrasSortable from "views/ExtrasSortable";

import AuthLogin from "views/AuthLogin";
import AuthForgotPassword from "views/AuthForgotPassword";
import AuthRegister from "views/AuthRegister";
import Error403 from "views/Error403";
import Error404 from "views/Error404";
import Error500 from "views/Error500";
import ErrorUnderMaintenance from "views/ErrorUnderMaintenance";
import BlogList from "views/BlogList";
import BlogListCardRows from "views/BlogListCardRows";
import BlogListCardColumns from "views/BlogListCardColumns";
import BlogAdd from "views/BlogAdd";
import PagesPricing from "views/PagesPricing";
import PagesFAQsLayout1 from "views/PagesFAQsLayout1";
import PagesFAQsLayout2 from "views/PagesFAQsLayout2";
import PagesInvoice from "views/PagesInvoice";

import ApplicationsMediaLibrary from "views/ApplicationsMediaLibrary";
import ApplicationsPointOfSale from "views/ApplicationsPointOfSale";
import ApplicationsToDo from "views/ApplicationsToDo";
import ApplicationsChat from "views/ApplicationsChat";

import Books from "views/Books";
import News from "views/News";
import Profile from "views/Profile";
import Insights from "views/Insights";
import Roles from "views/Roles";
import Sustainability from "views/Sustainability";
import PracticeAreas from "views/PracticeAreas";
import Articles from "views/Articles";
import Podcasts from "views/Podcasts";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");
  return token ? children : <Navigate to="/auth-login" replace />;
};

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");
  return token ? <Navigate to="/dashboard" replace /> : children;
};

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes - redirect to dashboard if already logged in */}
        <Route
          path="auth-login"
          element={
            <PublicRoute>
              <AuthLogin />
            </PublicRoute>
          }
        />
        <Route
          path="auth-register"
          element={
            <PublicRoute>
              <AuthRegister />
            </PublicRoute>
          }
        />
        <Route
          path="auth-forgot-password"
          element={
            <PublicRoute>
              <AuthForgotPassword />
            </PublicRoute>
          }
        />

        <Route element={<LayoutBlank />}>
          <Route path="*" element={<Error404 />} />
        </Route>

        <Route element={<LayoutDefault />}>
          {/* Root route - redirect based on auth status */}
          <Route
            index
            element={
              localStorage.getItem("access_token") ? (
                <Navigate replace to="/dashboard" />
              ) : (
                <Navigate replace to="/auth-login" />
              )
            }
          />

          {/* Protected Dashboard route */}
          <Route
            path="dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Other protected routes */}
          <Route
            path="books"
            element={
              <ProtectedRoute>
                <Books />
              </ProtectedRoute>
            }
          />

          <Route
            path="news"
            element={
              <ProtectedRoute>
                <News />
              </ProtectedRoute>
            }
          />

          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="insights"
            element={
              <ProtectedRoute>
                <Insights />
              </ProtectedRoute>
            }
          />
          <Route
            path="roles"
            element={
              <ProtectedRoute>
                <Roles />
              </ProtectedRoute>
            }
          />
          <Route
            path="sustainability"
            element={
              <ProtectedRoute>
                <Sustainability />
              </ProtectedRoute>
            }
          />
          <Route
            path="practice-areas"
            element={
              <ProtectedRoute>
                <PracticeAreas />
              </ProtectedRoute>
            }
          />
          <Route
            path="articles"
            element={
              <ProtectedRoute>
                <Articles />
              </ProtectedRoute>
            }
          />

          <Route
            path="podcasts"
            element={
              <ProtectedRoute>
                <Podcasts />
              </ProtectedRoute>
            }
          />
          <Route
            path="blank"
            element={
              <ProtectedRoute>
                <Blank />
              </ProtectedRoute>
            }
          />
          <Route
            path="form-components"
            element={
              <ProtectedRoute>
                <FormComponents />
              </ProtectedRoute>
            }
          />
          <Route
            path="form-input-groups"
            element={
              <ProtectedRoute>
                <FormInputGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="form-layout"
            element={
              <ProtectedRoute>
                <FormLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="form-validations"
            element={
              <ProtectedRoute>
                <FormValidations />
              </ProtectedRoute>
            }
          />
          <Route
            path="form-wizards"
            element={
              <ProtectedRoute>
                <FormWizards />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-alerts"
            element={
              <ProtectedRoute>
                <ComponentsAlerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-avatars"
            element={
              <ProtectedRoute>
                <ComponentsAvatars />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-badges"
            element={
              <ProtectedRoute>
                <ComponentsBadges />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-buttons"
            element={
              <ProtectedRoute>
                <ComponentsButtons />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-cards"
            element={
              <ProtectedRoute>
                <ComponentsCards />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-collapse"
            element={
              <ProtectedRoute>
                <ComponentsCollapse />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-colors"
            element={
              <ProtectedRoute>
                <ComponentsColors />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-dropdowns"
            element={
              <ProtectedRoute>
                <ComponentsDropdowns />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-modal"
            element={
              <ProtectedRoute>
                <ComponentsModal />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-popovers-tooltips"
            element={
              <ProtectedRoute>
                <ComponentsPopoversTooltips />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-tabs"
            element={
              <ProtectedRoute>
                <ComponentsTabs />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-tables"
            element={
              <ProtectedRoute>
                <ComponentsTables />
              </ProtectedRoute>
            }
          />
          <Route
            path="components-toasts"
            element={
              <ProtectedRoute>
                <ComponentsToasts />
              </ProtectedRoute>
            }
          />
          <Route
            path="extras-carousel"
            element={
              <ProtectedRoute>
                <ExtrasCarousel />
              </ProtectedRoute>
            }
          />
          <Route
            path="extras-charts"
            element={
              <ProtectedRoute>
                <ExtrasCharts />
              </ProtectedRoute>
            }
          />
          <Route
            path="extras-editors"
            element={
              <ProtectedRoute>
                <ExtrasEditors />
              </ProtectedRoute>
            }
          />
          <Route
            path="extras-fullcalendar"
            element={
              <ProtectedRoute>
                <ExtrasFullCalandar />
              </ProtectedRoute>
            }
          />
          <Route
            path="extras-sortable"
            element={
              <ProtectedRoute>
                <ExtrasSortable />
              </ProtectedRoute>
            }
          />
          <Route
            path="blog-list"
            element={
              <ProtectedRoute>
                <BlogList />
              </ProtectedRoute>
            }
          />
          <Route
            path="blog-list-card-rows"
            element={
              <ProtectedRoute>
                <BlogListCardRows />
              </ProtectedRoute>
            }
          />
          <Route
            path="blog-list-card-columns"
            element={
              <ProtectedRoute>
                <BlogListCardColumns />
              </ProtectedRoute>
            }
          />
          <Route
            path="blog-add"
            element={
              <ProtectedRoute>
                <BlogAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="pages-pricing"
            element={
              <ProtectedRoute>
                <PagesPricing />
              </ProtectedRoute>
            }
          />
          <Route
            path="pages-faqs-layout-1"
            element={
              <ProtectedRoute>
                <PagesFAQsLayout1 />
              </ProtectedRoute>
            }
          />
          <Route
            path="pages-faqs-layout-2"
            element={
              <ProtectedRoute>
                <PagesFAQsLayout2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="pages-invoice"
            element={
              <ProtectedRoute>
                <PagesInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="applications-media-library"
            element={
              <ProtectedRoute>
                <ApplicationsMediaLibrary />
              </ProtectedRoute>
            }
          />
          <Route
            path="applications-point-of-sale"
            element={
              <ProtectedRoute>
                <ApplicationsPointOfSale />
              </ProtectedRoute>
            }
          />
          <Route
            path="applications-to-do"
            element={
              <ProtectedRoute>
                <ApplicationsToDo />
              </ProtectedRoute>
            }
          />
          <Route
            path="applications-chat"
            element={
              <ProtectedRoute>
                <ApplicationsChat />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
